// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  connectionId: __t.connectionId().primaryKey().name("connection_id"),
  identity: __t.identity(),
  orgId: __t.string().name("org_id"),
  projectId: __t.string().name("project_id"),
  userId: __t.string().name("user_id"),
  name: __t.string(),
  avatarUrl: __t.string().name("avatar_url"),
  color: __t.string(),
  playheadUs: __t.f64().name("playhead_us"),
  selection: __t.array(__t.string()),
  cursorUs: __t.f64().name("cursor_us"),
  cursorTrackId: __t.string().name("cursor_track_id"),
  playing: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
  scopeId: __t.string().name("scope_id"),
  leading: __t.bool(),
});
